<template>
    <div @mouseover="isHovered = true"
         @mouseleave="isHovered = false"
         :id="id"
         class="form-group position-relative">

        <AppParamHeader :label="model.label" :showRequiredMark="model.required && !value"/>

        <AppMapParamCodeEditor
            v-if="isCodeEditorView"
            :id="`code-editor-${id}`"
            :key="`code-editor-${id}`"
            :value="value"
            :block="block"
            :disabled="disabled"
            @change="onChange"/>
        <AppMapParamQuillEditor
            v-else
            :id="`quill-editor-${id}`"
            :key="`quill-editor-${id}`"
            :value="value"
            @change="onChange"
            :disabled="disabled"
            :block="block"
            :isEvaluationExpression="isEvaluationExpression"
            :objectRefOnly="objectRefOnly"/>

        <div v-if="isHovered && !disabled"
             v-tooltip="`View in ${isCodeEditorView ? 'quill' : 'code'} editor`"
             @click="toggleEditorType"
             :class="{ 'text-muted': disabled }"
             class="switch-editor-btn border">
            <span v-show="!isCodeEditorView">
                <i class="fal fa-code"></i>
            </span>
            <span v-show="isCodeEditorView">
                <i class="fal fa-pencil-paintbrush"></i>
            </span>
        </div>
    </div>
</template>

<script>
import {getRandomId} from '../../../utils'
import AppParamHeader from '../header/AppParamHeader'
import AppMapParamQuillEditor from './quill-editor/AppMapParamQuillEditor'
import AppMapParamCodeEditor from './code-editor/AppMapParamCodeEditor'

export default {
    name: 'AppMapParam',
    components: {AppMapParamCodeEditor, AppMapParamQuillEditor, AppParamHeader},
    props: {
        id: {
            type: String,
            required: false,
            default: getRandomId.bind(null, 'map-param')
        },
        prop: {
            // type: [String, Array], // Array - path to nested prop
            // required: true
        },
        model: {
            // String - RPC https://zudello.gitbook.io/zudello-workflows/structure-blocks/mappable-parameters#rpc
            type: [Object, String],
            required: true
        },
        value: {},
        block: {
            // type: Object,
            required: true
        },
        objectRefOnly: { // for datastore operation => disable typing + remove {{ }}
            type: Boolean,
            required: false,
            default: false
        },
        isEvaluationExpression: { // means that the whole value will be wrapped with {{ }} (without any other parenthesis between)
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isHovered: false,
            isCodeEditorView: false
        }
    },
    methods: {
        onChange(value) {
            if (this.isCodeEditorView) {
                value = `{{ ${value} }}`
            }
            this.$emit('change', {prop: this.prop, value})
        },

        toggleEditorType() {
            if (this.disabled) {
                return
            }
            this.isCodeEditorView = !this.isCodeEditorView
        }
    }
}
</script>

<style lang="scss" scoped>
    .switch-editor-btn {
        position: absolute;
        top: 29px;
        right: 8px;
        padding: 4px 8px;
        background: white;
        border-radius: 3px;
        z-index: 2;

        &:hover {
            cursor: pointer;
        }
    }

    .code-editor {
        height: 120px;
    }
</style>

<style lang="scss">
    .highlighted-param {
        &:before {
            content: "";
            display: block;
            position: absolute;
            top: 21px;
            height: calc(100% - 21px);
            left: -4px;
            width: 4px;
            border-right: 4px solid $color-purple-light;
            border-radius: 4px;
        }
    }

    .map-param-menu {
        position: absolute;
        right: 344px;
        top: 16px;
        width: 300px;
        height: calc(100% - 80px);
        overflow-y: auto;
        background: white;
        box-shadow: $box-shadow;
        border: 1px solid $color-white-muted;
        border-radius: 3px;
    }
</style>
